import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicenseVerificationService {

  constructor(private httpClient: HttpClient) {}

  validateBeatSoundLicense(licenseId: string , type:string): Observable<any> {
    if (type === 'sound') {
      const url = `${environment.apiBaseUrl}sounds/licence/validate/${licenseId}`;
      return this.httpClient.get(url);
    }
    const url = `${environment.apiBaseUrl}beat/licence/validate/${licenseId}`;
    return this.httpClient.get(url);
  }
}
